module.exports = __webpack_public_path__ + "img/partnership-selection-bottom.2541f16e.jpg";